import { Directive, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ScrollControllerService } from '~/shared/services/scroll-controller.service';
import { IonContent } from '@ionic/angular';

@Directive({
  //eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ion-content',
  providers: [ScrollControllerService],
  standalone: true
})
export class ScrollDirective implements OnInit, OnDestroy {
  constructor(
    private readonly scrollControllerService: ScrollControllerService,
    private readonly viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit() {
    const component = this.viewContainerRef && this.viewContainerRef.injector && this.viewContainerRef.injector.get(IonContent);
    if (component) {
      this.scrollControllerService.setIonContent(component, (component as any).el.classList.contains('autoScrollOnKeyboardOpen'));
    }
  }

  ngOnDestroy() {
    this.scrollControllerService.destroy();
  }
}
